//TODO: TEMP copy of cwan-ux package component. Found here:
// https://gitlab.com/clearwateranalytics/apps/UIUX/cwan-ux/-/blob/master/packages/cwan-ux-core-react/src/components/TopNavigation.tsx

import { TopNavigation } from '@/components/Base/TEMP-TopNav/TopNavigation'
import DarkModeIcon from '@/components/ReportDashboard/Shared/DarkModeIcon'
import React from 'react'
import { Link } from 'react-router-dom'

interface ReportSchedulesTopNavProps {
  currentPath?: string
  isDarkMode: boolean
  onDarkModeToggle: (isDarkMode: boolean) => void
}

const ReportSchedulesTopNav = ({
  currentPath = '/factor-analytics/report-schedules',
  isDarkMode,
  onDarkModeToggle,
}: ReportSchedulesTopNavProps): React.ReactElement => (
  <div style={{ padding: '12px 24px 0', marginBottom: '30px' }}>
    <TopNavigation
      currentPath={currentPath}
      linkComponent={Link}
      utilityActions={[
        {
          ariaLabel: isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode',
          icon: <DarkModeIcon isDarkMode={isDarkMode} />,
          onClick: () => onDarkModeToggle(!isDarkMode),
        },
      ]}
    >
      <TopNavigation.Brand to="/factor-analytics/report-schedules">Report Schedules</TopNavigation.Brand>
      <TopNavigation.Link to="/factor-analytics">Return to Factor Analytics</TopNavigation.Link>
    </TopNavigation>
  </div>
)

export default ReportSchedulesTopNav
